import Footer from "../Homepages/Footer";
import {BsArrowLeft, BsPlusCircleFill} from 'react-icons/bs';
import { useNavigate, Link } from "react-router-dom";

export default function NewGrat() {
  const navigate = useNavigate();
  return (
    <div className="container px-4 px-md-5">
      <div className="heading mb-5 mt-5">
        <BsArrowLeft 
          size='30px' style={{cursor:"pointer"}}
          onClick={()=>{navigate('/home')}}
        />
        <h3 className="text-center no-wrap">Count my blessings</h3>
      </div>
      <div className="container center">
        <h2 style={{fontWeight:"bold"}}>What are you thankful for?</h2>
        <p className="text-center" style={{color:"#929292"}}>Click the button below to start counting your blessings</p>
      </div>
      <Link to='/newGrat'><BsPlusCircleFill color="#F39237" size="40px" style={{cursor:"pointer"}} className="arr"/></Link>
      <Footer />
    </div>
  );
}
